export default __webpack_public_path__ + "static/mobile_11-0743ad9f53edd2166c2d6e4a7909bea7.webp";